import { getSocket } from '@src/App';

export default async ({
  gameId,
  room,
  message,
}: { gameId?: string; room?: string; message: string }) => {
  try {
    if (room) {
      getSocket().emit('chat', { room, message });
    } else if (gameId) {
      getSocket().emit('chat', { gameId, message });
    }
  } catch (e) {
    console.log(e);
  }
};
